"use client";

import { useCallback, useEffect, useRef, useState } from "react";

type BeamTracker = {
  trackEvent: (category: string, action: string, tags: {}, fields: {}, source: string | null) => void;
};

export const useTrackBeamEvent = () => {
  // @todo rework for global storage.
  const [events, setEvents] = useState([] as object[]);
  const timerRef = useRef<number | ReturnType<typeof setTimeout>>();

  const addBeamTrackEvent = useCallback((newEvent: object | any) => {
    // Temporary Hack until We Solve Remp tracking issue.
    if (newEvent.user?.subscription_end_timestamp || newEvent.user?.subscription_initial_timestamp) {
      newEvent.user.subscription_initial = newEvent.user.subscription_initial_timestamp;
      newEvent.user.subscription_end = newEvent.user.subscription_end_timestamp;
    }
    if (newEvent.user?.is_user_logged) {
      newEvent.user.is_user_logged = newEvent.user.is_user_logged === "logged in" ? true : false;
    }
    if (newEvent.content === "null") {
      newEvent.content = {};
    }
    if (newEvent.content?.content_has_image) {
      newEvent.content.content_has_image = newEvent.content.content_has_image === "yes" ? true : false;
    }
    if (newEvent.content?.content_has_gallery) {
      newEvent.content.content_has_gallery = newEvent.content.content_has_gallery === "yes" ? true : false;
    }
    if (newEvent.content?.content_has_audio) {
      newEvent.content.content_has_audio = newEvent.content.content_has_audio === "yes" ? true : false;
    }
    setEvents((previousEvents) => [...previousEvents, newEvent]);
  }, []);

  const fireStoredEvents = useCallback(() => {
    const tracker = window.remplib?.tracker as BeamTracker;
    if (tracker) {
      events.forEach((data) => {
        tracker.trackEvent("pageview-custom", "load", {}, data, null);
      });
      setEvents([]);
      clearInterval(timerRef.current); // reset time, after successfully sending events.
    }
  }, [events]);

  // This whole thing is because, beam tracker is reinitialized on navigation.
  // So the reference to remplib, changes and need to be updated
  useEffect(() => {
    timerRef.current = setInterval(fireStoredEvents, 1000);
    return () => clearInterval(timerRef.current);
  }, [fireStoredEvents, events]);

  return addBeamTrackEvent;
};
